export const SET_CALLING_TO_USER = "SET_CALLING_TO_USER";
export const SET_ACTIVE_CALLER = "SET_ACTIVE_CALLER";
